exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#dify-chatbot-bubble-button {\r\n  background-color: #1C64F2 !important;\n}\n#dify-chatbot-bubble-window {\r\n  width: 24rem !important;\r\n  height: 40rem !important;\n}\r\n", ""]);

// exports
